module.exports = __webpack_public_path__ + "static/img/hzhb10.9ee8d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb10.png
// module id = EfBl
// module chunks = 0